<template>
  <CFooter :fixed="false">
    <div class="ml-auto">
      Oceanbolt Admin Interface
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
